module.exports = __webpack_public_path__ + "img/naalaim_no.a7db95a4.png";